var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import * as React from 'react';
import styles from './soundMeter.module.scss';
const recordingColor = 'red';
const notRecordingColor = '#9b9b9b';
const defaultWidth = '300';
const defaultHeight = '16';
export class SoundMeter extends React.PureComponent {
    constructor(props) {
        super(props);
        this.soundMeterRef = React.createRef();
        this.canvasRef = React.createRef();
        this.setupCanvas = this.setupCanvas.bind(this);
        this.setupCanvas = throttle(this.setupCanvas, 200);
    }
    componentDidMount() {
        this.setupCanvas();
        window.addEventListener('resize', this.setupCanvas);
    }
    componentDidUpdate(prevProps) {
        const { sounds } = this.props;
        if (sounds !== prevProps.sounds) {
            this.updateCanvas();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setupCanvas);
    }
    setupCanvas() {
        if (!this.soundMeterRef.current) {
            return;
        }
        const canvas = this.canvasRef.current;
        if (!canvas) {
            return;
        }
        const { width, height } = this.soundMeterRef.current.getBoundingClientRect();
        canvas.width = width;
        canvas.height = height;
        this.updateCanvas();
    }
    updateCanvas() {
        const { sounds } = this.props;
        const canvas = this.canvasRef.current;
        if (!canvas) {
            return;
        }
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            return;
        }
        ctx.fillStyle = notRecordingColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let prevIsRecording;
        sounds.slice(-canvas.width / 4).forEach((sound, index) => {
            if (sound.isRecording !== prevIsRecording) {
                ctx.fillStyle = sound.isRecording ? recordingColor : notRecordingColor;
            }
            prevIsRecording = sound.isRecording;
            const height = (sound.input + sound.output) * canvas.height;
            const y = (canvas.height - height) / 2;
            ctx.fillRect(index * 4, y, 2, height);
        });
    }
    render() {
        const _a = this.props, { className, sounds } = _a, otherProps = __rest(_a, ["className", "sounds"]);
        const rootClass = classnames({
            [styles.soundMeter]: true,
        }, className);
        return (_jsx("div", Object.assign({ ref: this.soundMeterRef }, otherProps, { className: rootClass }, { children: _jsx("canvas", { ref: this.canvasRef, width: defaultWidth, height: defaultHeight }) })));
    }
}
